import apiInstance from '@/api';
import { DealCenterFlag } from '@/models/GoldVision/GoldVisionDeal';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchDealFlags = createAsyncThunk<DealCenterFlag[]>(
  'dealsManagement/fetchDealFlags',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.deals.getDealCenterFlags();
      return response.data.data.results;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },
);
